// Components
import BarChartCard from "@/components/Dashboard/barChartCard";
import GaugeChartCard from "@/components/Dashboard/gaugeChartCard";
import Layout from "@/components/layout";
import {
  getShopSalesByAreaMan,
  getShopSalesWithTarget,
} from "@/fetch/fetchStatistics";
import currencyFormat from "@/lib/currencyFormat";
import splitStringInHalf from "@/lib/splitStringInHalf";
import Grid from "@mui/material/Grid2";
import _ from "lodash";
import moment from "moment";
import React from "react";
import { useNavigate } from "react-router-dom";

// Mui
const PromoterDashBoardPage = (props) => {
  const navigate = useNavigate();
  const { open, setOpen } = props;
  const timesGone = _.round(
    (parseInt(moment().format("D")) / moment().daysInMonth()) * 100,
    1
  );
  const [targetGaugeData, setTargetGaugeData] = React.useState({
    total: 0,
    current: 0,
  });
  const startDate = moment().startOf("month").format("YYYY-MM-DD");
  const endDate = moment().endOf("month").format("YYYY-MM-DD");

  const [amPerformanceChartData, setAmPerformanceChartData] = React.useState({
    loading: true,
    series: [],
    xAxis: [],
    height: 600,
    highlightScope: {
      additionalRadius: 10,
      faded: "global",
    },
  });
  const [
    shopPerformanceByAmountChartData,
    setShopPerformanceByAmountChartData,
  ] = React.useState({
    loading: true,
    series: [],
    xAxis: [],
    margin: { right: 5, left: 70 },
    height: 600,
    highlightScope: {
      additionalRadius: 10,
      faded: "global",
    },
  });
  const [
    shopPerformanceByTargerChartData,
    setShopPerformanceByTargerChartData,
  ] = React.useState({
    loading: true,
    series: [],
    xAxis: [],
    margin: { right: 5, left: 70 },
    height: 600,
    highlightScope: {
      additionalRadius: 10,
      faded: "global",
    },
  });
  const fetchShopPerformanceByTarget = async () => {
    const seriesTargetAmountData = {
      id: "sales-target-amount",
      data: [],
      label: `目標`,
      stack: "total",
      color: "#FF5733",
      highlightScope: {
        highlighted: "item",
      },
    };
    const seriesSalesData = {
      id: "sales-sales-targer",
      data: [],
      label: `銷售`,
      stack: "total",
      highlightScope: {
        highlighted: "item",
      },
    };
    const { data: salesByAmount } = await getShopSalesWithTarget(
      {
        startDate,
        endDate,
        district: [],
        area: [],
        shop: [],
        am: [123, 122, 126, 170],
      },
      "target",
      "DESC",
      "10",
      false
    );
    const { data: salesByTarget } = await getShopSalesWithTarget(
      {
        startDate,
        endDate,
        district: [],
        area: [],
        shop: [],
        am: [123, 122, 126, 170],
      },
      "percent",
      "ASC",
      "10",
      false
    );
    const shopAmountLabel = _.map(salesByAmount, (s) => {
      const { total, target_total_amount } = s;
      const salesTotal = parseInt(total);
      if (salesTotal > target_total_amount) {
        seriesTargetAmountData.data.push(0);
        seriesSalesData.data.push(salesTotal);
      } else {
        seriesTargetAmountData.data.push(target_total_amount - salesTotal);
        seriesSalesData.data.push(salesTotal);
      }
      return `${s.work_shortcode}-${s.work_name}`;
    });

    setShopPerformanceByAmountChartData({
      ...shopPerformanceByAmountChartData,
      series: [
        {
          ...seriesSalesData,
          valueFormatter: (value, { dataIndex }) => {
            if (dataIndex < 0) return;
            const { total, percent } = salesByAmount[dataIndex];
            return `${currencyFormat(total)} (${_.round(percent * 100, 2)}%)`;
          },
        },
        {
          ...seriesTargetAmountData,
          valueFormatter: (value, { dataIndex }) => {
            if (dataIndex < 0) return;
            const { target_total_amount } = salesByAmount[dataIndex];
            return `${currencyFormat(target_total_amount)}`;
          },
        },
      ],
      loading: false,
      xAxis: [
        {
          data: shopAmountLabel,
          scaleType: "band",
          id: "axis1",
          labelStyle: {
            // Move the x-axis label with style
            transform: "translateY(30px)",
          },
          valueFormatter: (value, context) => {
            const split = value.split("-");
            return `${split[0]}\n${splitStringInHalf(split[1])}`;
          },
        },
      ],
    });
    const seriesSalesData1 = {
      id: "sales-amount",
      data: [],
      label: `銷售`,
      stack: `total`,
      highlightScope: {
        highlighted: "item",
      },
    };
    const seriesOffTargetData = {
      id: "target-off",
      data: [],
      label: "目標",
      stack: "total",
      color: "#FF0000",
      highlightScope: {
        highlighted: "item",
      },
      valueFormatter: (value) => `${value}%`,
    };
    const seriesOverTargetData = {
      id: "target-over",
      data: [],
      label: "高於目標",
      stack: "total",
      color: "#FFE633",
      highlightScope: {
        highlighted: "item",
      },
      valueFormatter: (value) => `${value}%`,
    };

    const shopTargetLabel = _.map(salesByTarget, (s) => {
      const { percent } = s;
      if (percent >= 1) {
        seriesSalesData1.data.push(100);
        seriesOverTargetData.data.push(_.round((percent - 1) * 100, 2));
        seriesOffTargetData.data.push(0);
      } else {
        seriesSalesData1.data.push(_.round(percent * 100, 2));
        seriesOverTargetData.data.push(0);
        seriesOffTargetData.data.push(_.round((1 - percent) * 100, 2));
      }
      return `${s.work_shortcode}-${s.work_name}`;
    });

    setShopPerformanceByTargerChartData({
      ...shopPerformanceByTargerChartData,
      series: [
        {
          ...seriesSalesData1,
          valueFormatter: (value, { dataIndex }) => {
            if (dataIndex < 0) return;
            const { total } = salesByTarget[dataIndex];
            return `${currencyFormat(total)} (${value}%)`;
          },
        },
        {
          ...seriesOffTargetData,
          valueFormatter: (value, { dataIndex }) => {
            if (dataIndex < 0) return;
            const { target_total_amount } = salesByTarget[dataIndex];
            return `${currencyFormat(target_total_amount)}`;
          },
        },
        {
          ...seriesOverTargetData,
          valueFormatter: (value, { dataIndex }) => {
            if (dataIndex < 0) return;
            const { target_total_amount, total } = salesByTarget[dataIndex];
            if (parseInt(total) > parseInt(target_total_amount)) {
              return `${currencyFormat(
                parseInt(total) - parseInt(target_total_amount)
              )}`;
            } else {
              return `${currencyFormat(0)}`;
            }
          },
        },
      ],
      loading: false,
      xAxis: [
        {
          data: shopTargetLabel,
          scaleType: "band",
          id: "axis1",
          valueFormatter: (value, context) => {
            const split = value.split("-");
            return `${split[0]}\n${splitStringInHalf(split[1])}`;
          },
        },
      ],
    });
  };
  const fetchAmPerformance = async () => {
    const { data } = await getShopSalesByAreaMan(
      {
        startDate,
        endDate,
        district: [],
        area: [],
        shop: [],
        am: [123, 122, 126, 170],
      },
      false
    );
    setTargetGaugeData({
      total: _.sumBy(data, (d) => parseInt(d.target_total_amount)),
      current: _.sumBy(data, (d) => parseInt(d.sales_total)),
    });
    const seriesData = {
      id: "sales-amount",
      data: [],
      label: `銷售`,
      stack: `total`,
      highlightScope: {
        highlighted: "item",
      },
    };
    const seriesTargetData = {
      id: "target-off",
      data: [],
      label: "目標",
      stack: "total",
      color: "#FF0000",
      highlightScope: {
        highlighted: "item",
      },
    };
    const seriesOverTargetData = {
      id: "target-over",
      data: [],
      label: "高於目標",
      stack: "total",
      color: "#FFE633",
      highlightScope: {
        highlighted: "item",
      },
      valueFormatter: (value) => `${value}%`,
    };
    const am_label = _.map(data, (d) => {
      const sales_total = parseInt(d.sales_total);
      const target_total = parseInt(d.target_total_amount);
      const percent = _.round((sales_total / target_total) * 100, 2);
      if (!_.isFinite(percent)) {
        seriesData.data.push(0);
        seriesOverTargetData.data.push(0);
        seriesTargetData.data.push(0);
      } else if (percent >= 100) {
        seriesData.data.push(100);
        seriesOverTargetData.data.push(_.round(percent - 100, 2));
        seriesTargetData.data.push(0);
      } else {
        seriesData.data.push(percent);
        seriesOverTargetData.data.push(0);
        seriesTargetData.data.push(_.round(100 - percent, 2));
      }

      return d.alias;
    });

    const chart = {
      ...amPerformanceChartData,
      series: [
        {
          ...seriesData,
          valueFormatter: (value, { dataIndex }) => {
            if (dataIndex < 0) return;
            const { sales_total } = data[dataIndex];
            return `${currencyFormat(sales_total)} (${value}%)`;
          },
        },
        {
          ...seriesTargetData,
          valueFormatter: (value, { dataIndex }) => {
            if (dataIndex < 0) return;
            const { target_total_amount } = data[dataIndex];
            if (value === 0) {
              return "未設定目標";
            }
            return `${currencyFormat(target_total_amount)}`;
          },
        },
        {
          ...seriesOverTargetData,
          valueFormatter: (value, { dataIndex }) => {
            if (dataIndex < 0) return;
            const { target_total_amount, sales_total } = data[dataIndex];
            if (parseInt(sales_total) > parseInt(target_total_amount)) {
              return `${currencyFormat(
                parseInt(sales_total) - parseInt(target_total_amount)
              )}`;
            } else {
              return `${currencyFormat(0)}`;
            }
          },
        },
      ],
      loading: false,
      xAxis: [
        {
          data: am_label,
          scaleType: "band",
          id: "axis1",
        },
      ],
    };
    setAmPerformanceChartData(chart);
  };
  React.useEffect(() => {
    fetchAmPerformance();
    fetchShopPerformanceByTarget();
  }, []);

  return (
    <Layout header="Main Page" selectedIndex={1} open={open} setOpen={setOpen}>
      <Grid container spacing={2}>
        {/* <Grid size={2}>
          <SparkLineChartCard />
        </Grid> */}
        <Grid container size={6}>
          <Grid size={6}>
            <GaugeChartCard
              value={_.round(
                (targetGaugeData.current / targetGaugeData.total) * 100,
                1
              )}
              name={"Target"}
              caption={`${currencyFormat(
                targetGaugeData.current
              )}/ ${currencyFormat(targetGaugeData.total)}`}
            ></GaugeChartCard>
          </Grid>
          <Grid size={6}>
            <GaugeChartCard
              value={timesGone}
              name={"Times Gone"}
              caption={moment().format("YYYY-MM-DD")}
            ></GaugeChartCard>
          </Grid>
          <Grid size={12}>
            <BarChartCard
              onClick={() => navigate("/shopSalesChart")}
              data={amPerformanceChartData}
              caption={moment().format("YYYY-MM")}
              name={"AM Performance"}
            ></BarChartCard>
          </Grid>
        </Grid>
        <Grid container size={6}>
          <Grid size={12}>
            <BarChartCard
              onClick={() =>
                navigate("/shopSalesChart", {
                  state: {
                    limit: 10,
                    orderBy: "percent",
                    ordering: "ASC",
                    mode: "all",
                  },
                })
              }
              data={shopPerformanceByTargerChartData}
              caption={moment().format("YYYY-MM")}
              name={"Shop Performance(By Target)"}
            ></BarChartCard>
          </Grid>
          <Grid size={12}>
            <BarChartCard
              onClick={() =>
                navigate("/shopSalesChart", {
                  state: {
                    limit: 10,
                    orderBy: "target",
                    ordering: "DESC",
                    mode: "all",
                    showAmount: true,
                  },
                })
              }
              data={shopPerformanceByAmountChartData}
              caption={moment().format("YYYY-MM")}
              name={"Shop Performance(By amount)"}
            ></BarChartCard>
          </Grid>
        </Grid>
      </Grid>
    </Layout>
  );
};

export default PromoterDashBoardPage;
